/* eslint-disable function-paren-newline */
import Loadable from 'react-loadable';
import { Loading } from 'utilsModule/components';

export default Loadable({
  loader: () => import(
    /* webpackChunkName: 'policies' */
    /* webpackPrefetch: true */
    '../containers/Policy',
  ),
  loading: Loading,
});
